import styled from "@emotion/styled";
import { LinearProgress, linearProgressClasses } from "@mui/material";
import Box from "@mui/material/Box";
// import LinearProgress from "@mui/material/LinearProgress";
// import linearProgressClasses from "@mui/material/LinearProgress";

import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useSelector } from "react-redux";

const todaysData = [
  {
    id: 1,
    title: "Today's Revenue",
    value: 0,
    progressValue: 0,
    changes: "No changes since yesterday",
  },
  {
    id: 2,
    title: "Today's Orders",
    value: 10,
    progressValue: 20,
    changes: "No changes since yesterday",
  },
  {
    id: 3,
    title: "Today's Distance",
    value: 0,
    progressValue: 0,
    changes: "No changes since yesterday",
  },
];

export const TodayInfoBox = () => {
  const { mode } = useSelector((state) => state.mode);

  const InfoTypography = styled(Typography)(({ theme }) => ({
    // color: theme.palette.secondary.main,
    fontFamily: "'Open Sans', sans-serif",
    fontWeight: "600",
    fontSize: "15px",
    lineHeight: "24px",
  }));

  const InfoValueTypography = styled(Typography)(({ theme }) => ({
    // color: theme.palette.secondary.main,
    fontFamily: "'Open Sans', sans-serif",
    fontWeight: "700",
    fontSize: "30px",
  }));
  const InfoSubtitleTypography = styled(Typography)(({ theme }) => ({
    color: "#8F9BB3",
    fontFamily: "'Open Sans', sans-serif",
    fontWeight: "400",
    fontSize: "12px",
  }));

  const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 20,
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
      backgroundColor: mode === "light" ? "#EDF1F7" : "#151A30",
    },
    [`& .${linearProgressClasses.bar}`]: {
      borderRadius: 5,
      backgroundColor: mode === "light" ? "#1a90ff" : "#308fe8",
    },
  }));

  return (
    <Box
      sx={{
        minHeight: 450,
      }}
      px={3}
      py={2}
      component={Paper}
      elevation={0}
      // border={"1px solid #e9ebf0"}
    >
      {todaysData.map((todaysData) => {
        const { title, value, progressValue, changes } = todaysData;
        return (
          <Stack key={todaysData.id} my={4} direction='column' spacing={1}>
            <InfoTypography>{title}</InfoTypography>
            <InfoValueTypography>{value}</InfoValueTypography>
            <BorderLinearProgress variant='determinate' value={progressValue} />
            <InfoSubtitleTypography>{changes}</InfoSubtitleTypography>
          </Stack>
        );
      })}
    </Box>
  );
};
